import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { getVerifyUserThunk } from '@/core/services/App/AppSlice'
import { useAppDispatch, useAppSelector } from '@/core/store/hooks'
import { userSelector } from '@/modules/Auth/store/AuthSelector'
import { getUserThunk } from '@/modules/Auth/store/AuthSlice'
import { cn } from '@bem-react/classname'
import SumsubWebSdk from '@sumsub/websdk-react'
import { AxiosResponse } from 'axios'

import { useHandleServerError } from '@/hooks/useHandleServerError'

import { Loading } from '@/components/UI/Loading'
import { Title } from '@/components/UI/Title'

import './Verify.scss'

const cnVerify = cn('Verify')

export const Verify: FC = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { handleServerError } = useHandleServerError()

  const [isLoading, setLoading] = useState<boolean>(true)
  const [token, setToken] = useState<string>('')

  const user = useAppSelector(userSelector)

  useEffect(() => {
    getVerifyUser()
  }, [])

  const accessTokenExpirationHandler = async () => {
    if (!user) return

    try {
      const res = await dispatch(
        getVerifyUserThunk({
          email: user.email,
          phone: user.phone,
        }),
      ).unwrap()
      return res.access_token
    } catch {
      return ''
    }
  }

  const getVerifyUser = async () => {
    if (!user) return

    try {
      const res = await dispatch(
        getVerifyUserThunk({
          email: user.email,
          phone: user.phone,
        }),
      ).unwrap()

      setToken(res.access_token)
      setLoading(false)
    } catch (error) {
      handleServerError(error)
      setLoading(false)

      const err = error as AxiosResponse
      if (err.data.error === 'is_verified' && err.status === 400) {
        navigate('/c')
        return
      }
    }
  }

  const getUser = async () => {
    try {
      await dispatch(getUserThunk()).unwrap()
    } catch (error) {
      handleServerError(error)
    }
  }

  const messageHandler = async (e: string) => {
    if (typeof e === 'string' && e === 'idCheck.onApplicantStatusChanged') {
      // Верификация успешна
      await getVerifyUser()
      await getUser()
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const errorHandler: any = (error: any) => {
    console.error('Sumsub error:', error)
    handleServerError(error)
  }

  return (
    <div className={cnVerify()}>
      <Title>{t('verify-title')}</Title>
      {isLoading ? (
        <Loading type='circle' minHeight='300px' />
      ) : (
        <SumsubWebSdk
          accessToken={token}
          expirationHandler={accessTokenExpirationHandler}
          config={
            {
              // Язык интерфейса
              // lang: 'en',
              // // Цветовая тема
              // theme: {
              //   // Основной цвет бренда
              //   primaryColor: '#A867FC',
              //   // Цвет успешного действия
              //   successColor: '#26BE6D',
              //   // Цвет ошибки
              //   errorColor: '#E9435C',
              //   // Основной цвет текста
              //   primaryTextColor: '#FFFFFF',
              //   // Вторичный цвет текста
              //   secondaryTextColor: 'rgba(255, 255, 255, 0.45)',
              //   // Цвет фона
              //   backgroundColor: '#121212',
              // },
              // // Кастомные CSS стили
              // uiConf: {
              //   customCssStr: `
              //     :root {
              //       --black: #121212;
              //       --white: #FFFFFF;
              //     }
              //   `,
              // },
              // // Отключение определенных шагов верификации
              // excludedSteps: [],
              // // Настройки для мобильных устройств
              // mobileTrigger: 'auto',
              // // Настройки для загрузки документов
              // documentsByCountry: true,
              // // Email пользователя для уведомлений
              // email: user?.email,
              // // Телефон пользователя для уведомлений
              // phone: user?.phone,
              // // Настройки для фотографий
              // allowedDocumentTypes: ['PASSPORT', 'ID_CARD', 'DRIVERS'],
              // // Настройки для селфи
              // requireSelfie: true,
              // // Настройки для видеоидентификации
              // requireVideo: false,
              // // Настройки для проверки лица
              // requireLiveness: true,
            }
          }
          options={{
            // Дополнительные параметры для SDK
            addViewportTag: false,
            adaptIframeHeight: true,
          }}
          onMessage={messageHandler}
          onError={errorHandler}
        />
      )}
    </div>
  )
}
